import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { ArrowLeftOnRectangleIcon } from '@heroicons/react/24/outline';
import { ADMIN_NAV_ITEMS } from './adminNavigation';

const AdminSidebar: React.FC = () => {
  const commonLinkClass =
    'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-150';
  const activeLinkClass = 'bg-ratuj-300/16 text-ratuj-200 ring-1 ring-ratuj-300/18';
  const inactiveLinkClass = 'text-primary-light-300 hover:bg-primary-dark-300/36 hover:text-white';

  return (
    <aside
      className="hidden md:flex md:h-screen md:w-64 md:flex-shrink-0 md:flex-col md:sticky md:top-0 md:border-r md:border-primary-dark-300/42 md:bg-primary-dark-200/78"
      aria-label="Sidebar"
    >
      <div className="border-b border-primary-dark-300/60 px-5 py-5">
        <h2 className="text-lg font-semibold text-primary-light-100">Panel Admina</h2>
        <p className="mt-1 text-xs text-primary-light-400">Widok operacyjny</p>
      </div>
      <nav className="flex-grow space-y-1.5 overflow-y-auto px-3 py-4">
        {ADMIN_NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.key}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `${commonLinkClass} ${isActive ? activeLinkClass : inactiveLinkClass}`
              }
            >
              <Icon className="h-5 w-5 flex-shrink-0" />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
      <div className="space-y-2 border-t border-primary-dark-300/60 px-3 py-4">
        <Link to="/" className={`${commonLinkClass} ${inactiveLinkClass}`}>
          <ArrowLeftOnRectangleIcon className="h-5 w-5 flex-shrink-0" />
          Wyjdź z trybu admina
        </Link>
        <p className="text-center text-xs text-primary-light-500">Ratuj Sprzęt Admin</p>
      </div>
    </aside>
  );
};

export default AdminSidebar;
